import { useRef } from "react";

/* ALUMNI IMAGES */
import vikramImage from "../../assets/Alumnis/IMG_5958.JPG.jpeg";
import lakshmiImage from "../../assets/Alumnis/IMG_5965.JPG.jpeg";
import aravindImage from "../../assets/Alumnis/IMG_5963.JPG.jpeg";
import harishImage from "../../assets/Alumnis/IMG_5960_copy.JPG.jpeg";
import pavanImage from "../../assets/Alumnis/IMG_5961.JPG.jpeg";

/* COMPANY LOGOS */
import copartLogo from "../../assets/Alumnis/companies/Copart_logo.svg.png";
import bnpLogo from "../../assets/Alumnis/companies/bnp.jpg";
import lebaraLogo from "../../assets/Alumnis/companies/New_Logo_Lebara.png";
import atosLogo from "../../assets/Alumnis/companies/atos.jpg";
import qualizealLogo from "../../assets/Alumnis/companies/qualizeal.png";

const stories = [
  {
    name: "Vikram Paleti",
    companyLogo: copartLogo,
    from: "Argano",
    to: "Persist Ventures",
    image: vikramImage,
    quote:
      "Enrolling in Practical Infosec was a turning point in my career. The Senior Penetration Tester program helped me significantly upskill with hands-on, real-world training.",
  },
  {
    name: "M Lakshmi",
    companyLogo: bnpLogo,
    from: "IBM with 110% Salary Hike",
    to: "",
    image: lakshmiImage,
    quote:
      "The Senior Penetration Tester program made my transition from non-IT to cybersecurity seamless through hands-on practical training.",
  },
  {
    name: "Aravind Sai",
    companyLogo: lebaraLogo,
    from: "RTDS",
    to: "",
    image: aravindImage,
    quote:
      "Practical Infosec’s live sessions and well-structured curriculum played a key role in my learning journey. They helped me build the confidence and skills required to execute complex VAPT projects effectively.",
  },
  {
    name: "Harish Rangisetty",
    companyLogo: atosLogo,
    from: "Infosys",
    to: "Mastercard",
    image: harishImage,
    quote:
      "Practical Infosec’s live classes, mock interviews, and personalized guidance gave me the clarity and confidence to effectively upskill in VAPT.",
  },
  {
    name: "Pavan Dileep",
    companyLogo: qualizealLogo,
    from: "TCS",
    to: "Amazon",
    image: pavanImage,
    quote:
      "Structured program, live sessions gave me the push I needed to transition smoothly into a better role.",
  },
];

function AlumniSuccessStories() {
  const sliderRef = useRef(null);

  const moveSlider = (direction) => {
    const slider = sliderRef.current;
    if (!slider) return;

    slider.scrollBy({
      left: direction * 420,
      behavior: "smooth",
    });
  };

  const loopStories = [...stories, ...stories];

  return (
    <section className="relative w-full px-3 py-8 overflow-hidden sm:px-5">
      <div className="absolute inset-0 bg-gradient-to-b from-white via-slate-50 to-white"></div>

      <div className="relative mx-auto max-w-[1700px] overflow-hidden rounded-[2.5rem] border border-white/80 bg-gradient-to-br from-[#eefbf3] via-white to-[#eef6ff] px-4 py-12 shadow-[0_35px_110px_rgba(15,23,42,0.12)] sm:px-8 md:px-14 md:py-16">
        <div className="absolute w-64 h-64 rounded-full -left-24 top-20 bg-cyan-300/25 blur-3xl"></div>
        <div className="absolute rounded-full w-72 h-72 -right-24 bottom-10 bg-blue-400/20 blur-3xl"></div>
        <div className="absolute w-56 h-56 -translate-x-1/2 rounded-full left-1/2 top-10 bg-emerald-300/20 blur-3xl"></div>

        <div className="relative z-10 max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center justify-center gap-3 rounded-full border border-slate-200 bg-white/80 px-5 py-2 text-[11px] font-black uppercase tracking-[0.22em] text-slate-500 shadow-sm backdrop-blur">
            <span className="w-6 h-px bg-gradient-to-r from-transparent to-blue-400"></span>
            Success Stories
            <span className="w-6 h-px bg-gradient-to-r from-blue-400 to-transparent"></span>
          </div>

          <h2 className="mt-6 text-3xl font-black leading-tight tracking-[-0.04em] text-slate-950 sm:text-4xl md:text-5xl">
            Practical Infosec Alumni{" "}
            <span className="text-transparent bg-gradient-to-r from-blue-700 via-cyan-600 to-emerald-600 bg-clip-text">
              Success Stories
            </span>
          </h2>

          <p className="max-w-3xl mx-auto mt-5 text-base font-semibold leading-8 text-slate-600">
            Real learners. Real career growth. Real-world cybersecurity training
            outcomes from our practical VAPT programs.
          </p>
        </div>

        <div className="relative z-10 mt-14">
          <button
            type="button"
            onClick={() => moveSlider(-1)}
            className="absolute left-0 z-30 flex items-center justify-center w-12 h-12 transition -translate-y-1/2 border rounded-full shadow-xl top-1/2 border-white/80 bg-white/90 text-slate-700 backdrop-blur-xl hover:scale-110 hover:bg-slate-950 hover:text-white sm:left-4 sm:h-14 sm:w-14"
            aria-label="Previous success story"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-6 h-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth="2.2"
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M15 18l-6-6 6-6" />
            </svg>
          </button>

          <button
            type="button"
            onClick={() => moveSlider(1)}
            className="absolute right-0 z-30 flex items-center justify-center w-12 h-12 transition -translate-y-1/2 border rounded-full shadow-xl top-1/2 border-white/80 bg-white/90 text-slate-700 backdrop-blur-xl hover:scale-110 hover:bg-slate-950 hover:text-white sm:right-4 sm:h-14 sm:w-14"
            aria-label="Next success story"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="w-6 h-6"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              strokeWidth="2.2"
            >
              <path strokeLinecap="round" strokeLinejoin="round" d="M9 6l6 6-6 6" />
            </svg>
          </button>

          <div
            ref={sliderRef}
            className="px-0 overflow-hidden sm:px-16"
          >
            <div className="flex gap-6 w-max alumni-auto-scroll">
              {loopStories.map((story, index) => (
                <SuccessStoryCard
                  key={`${story.name}-${index}`}
                  story={story}
                />
              ))}
            </div>
          </div>

          <p className="mt-8 text-xs font-bold text-center text-slate-400">
            Auto scrolling slowly. Hover on cards to pause.
          </p>
        </div>
      </div>
    </section>
  );
}

function SuccessStoryCard({ story }) {
  return (
    <article className="group relative flex min-h-[470px] w-[310px] flex-shrink-0 flex-col overflow-hidden rounded-[2rem] border border-slate-200 bg-white p-6 text-center shadow-xl transition-all duration-500 hover:-translate-y-2 hover:shadow-[0_35px_90px_rgba(37,99,235,0.18)] sm:w-[380px]">
      <div className="absolute inset-0 bg-gradient-to-br from-white via-white to-blue-50/80"></div>
      <div className="absolute w-24 h-24 transition rounded-full -right-10 -top-10 bg-cyan-300/30 blur-2xl group-hover:scale-150"></div>
      <div className="absolute w-24 h-24 transition rounded-full -left-10 bottom-8 bg-emerald-300/25 blur-2xl group-hover:scale-150"></div>

      <div className="relative z-10">
        <div className="relative inline-flex items-center justify-center">
          <div className="absolute inset-0 rounded-full bg-blue-400/30 blur-xl"></div>

          <img
            src={story.image}
            alt={story.name}
            className="relative object-cover w-24 h-24 border-4 border-white rounded-full shadow-xl"
          />
        </div>

        <h3 className="mt-5 text-2xl font-black tracking-tight text-slate-950">
          {story.name}
        </h3>

        <div className="flex justify-center mt-4">
          <div className="flex items-center justify-center h-12 px-5 border shadow-sm rounded-2xl bg-white/80 border-slate-200">
            <img
              src={story.companyLogo}
              alt={`${story.name} company logo`}
              className="object-contain max-w-[130px] h-8"
            />
          </div>
        </div>

        {/* <div className="px-4 py-3 mt-5 border rounded-2xl border-slate-200 bg-slate-50">
          <p className="text-[11px] font-black uppercase tracking-[0.18em] text-blue-700">
            Career Outcome
          </p>

          <p className="mt-2 text-sm font-black text-slate-800">
            {story.to ? (
              <>
                {story.from}
                <span className="mx-2 text-blue-600">→</span>
                {story.to}
              </>
            ) : (
              story.from
            )}
          </p>
        </div> */}

        <div className="relative mt-6">
          <div className="absolute left-0 font-black leading-none text-blue-100 -top-7 text-7xl">
            “
          </div>

          <p className="relative z-10 text-[15px] font-semibold leading-7 text-slate-600">
            {story.quote}
          </p>

          <div className="absolute right-0 font-black leading-none text-blue-100 -bottom-12 text-7xl">
            ”
          </div>
        </div>
      </div>
    </article>
  );
}

export default AlumniSuccessStories;